var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{ref:"images"},_vm._l((_vm.list),function(item,idx){return _c('li',{key:idx},[_c('img',{attrs:{"src":item[_vm.itemKey],"alt":"图片"}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }